import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  Button,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// action
import { registerUser, resetRegisterFlag } from "../../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import logoAiCare from "../../assets/images/pn.png";
import logoAiCareEsteso from "../../assets/images/aicare.png";
import loghiNazionali from "../../assets/images/loghi-nazionali.png";

//import images
//import logoLight from "../../assets/images/logo-light.png";
// import logoLight from "../../assets/images/landscapeV1.svg";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import { useQuery } from "@tanstack/react-query";
import { fetchRegisterRoles } from "api/queries/role";

const Register = (props: any) => {
  const history = useNavigate();
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);

  const {
    isPending,
    data,
    error: roleError,
  } = useQuery({
    queryKey: fetchRegisterRoles.queryKey(),
    queryFn: () => fetchRegisterRoles.queryFn(),
  });

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      name: "",
      surname: "",
      mainRoleId: data ? data[0].value : '',
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      name: Yup.string().required("Please Enter Your Name"),
      surname: Yup.string().required("Please Enter Your Surname"),
      mainRoleId: Yup.string().required("Please Enter Your Role"),
      password: Yup.string().required("Please Enter Your Password"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password")], "The passwords do not match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      dispatch(registerUser({...values, mainRoleId: Number(values.mainRoleId)}, history));
      setLoader(true);
    },
  });

  const selectLayoutState = (state: any) => state.Account;
  const registerdatatype = createSelector(selectLayoutState, (account) => ({
    success: account.success,
    error: account.error,
  }));
  // Inside your component
  const { error, success } = useSelector(registerdatatype);

  const handleChangeWithLoaderReset = (e: React.ChangeEvent<HTMLInputElement>) => {
      setLoader(false);
      validation.handleChange(e);
    };

  useEffect(() => {
    if (success) {
      setTimeout(() => history("/login"), 3000);
    }

    setTimeout(() => {
      dispatch(resetRegisterFlag());
    }, 3000);
  }, [dispatch, success, error, history]);

  document.title = "Registration";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <div
          className="mb-lg-5"
          style={{ textAlign: "center", backgroundColor: "#fff" }}
        >
          <span className="logo-lg">
            <img
              src={loghiNazionali}
              alt=""
              className="img-fluid"
              style={{ minHeight: 30, maxHeight: 80 }}
            />
          </span>
        </div>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoAiCare} alt="" height="45" />
                      <img src={logoAiCareEsteso} alt="" height="45" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Crea il tuo Account</h5>
                      <p className="text-muted">Registrati</p>
                    </div>
                    <div className="p-2 mt-4">
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        className="needs-validation"
                        action="#"
                      >
                        {success && success ? (
                          <>
                            {toast("Your Redirect To Login Page...", {
                              position: "top-right",
                              hideProgressBar: false,
                              className: "bg-success text-white",
                              progress: undefined,
                              toastId: "",
                            })}
                            <ToastContainer autoClose={2000} limit={1} />
                            <Alert color="success">
                              Registrazione completata con successo! Verrai reindirizzato alla pagina di accesso...
                            </Alert>
                          </>
                        ) : null}

                        {error && error ? (
                          <Alert color="danger">
                            <div>
                              L'email è già stata registrata, si prega di utilizzare un'altra email...
                            </div>
                          </Alert>
                        ) : null}

                        <div className="mb-3">
                          <Label htmlFor="useremail" className="form-label">
                            Email <span className="text-danger">*</span>
                          </Label>
                          <Input
                            id="email"
                            name="email"
                            className="form-control"
                            placeholder="Enter email address"
                            type="email"
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.email &&
                          validation.errors.email ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.email}</div>
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Nome <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="name"
                            type="text"
                            placeholder="Enter name"
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                            value={validation.values.name || ""}
                            invalid={
                              validation.touched.name && validation.errors.name
                                ? true
                                : false
                            }
                          />
                          {validation.touched.name && validation.errors.name ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.name}</div>
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3">
                          <Label htmlFor="username" className="form-label">
                            Cognome <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="surname"
                            type="text"
                            placeholder="Enter surname"
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                            value={validation.values.surname || ""}
                            invalid={
                              validation.touched.surname &&
                              validation.errors.surname
                                ? true
                                : false
                            }
                          />
                          {validation.touched.surname &&
                          validation.errors.surname ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.surname}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="role" className="form-label">
                            Ruolo
                          </Label>
                          <Input
                            type="select"
                            id="mainRoleId"
                            name="mainRoleId"
                            className="form-select"
                            value={validation.values.mainRoleId}
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                          >
                            {data?.map((role: any) => (
                              <option
                                key={role.value}
                                value={role.value}
                              >
                                {role.label}
                              </option>
                            ))}
                          </Input>
                        </div>

                        <div className="mb-3">
                          <Label htmlFor="userpassword" className="form-label">
                            Password <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.password}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-2">
                          <Label
                            htmlFor="confirmPassword"
                            className="form-label"
                          >
                            Conferma Password{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="confirm_password"
                            type="password"
                            placeholder="Confirm Password"
                            onChange={handleChangeWithLoaderReset}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirm_password || ""}
                            invalid={
                              validation.touched.confirm_password &&
                              validation.errors.confirm_password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirm_password &&
                          validation.errors.confirm_password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.confirm_password}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        {/* <div className="mb-4">
                          <p className="mb-0 fs-12 text-muted fst-italic">
                            By registering you agree to the Linksafe{" "}
                            <Link
                              to="#"
                              className="text-primary text-decoration-underline fst-normal fw-medium"
                            >
                              Terms of Use
                            </Link>
                          </p>
                        </div> */}

                        <div className="mt-4">
                          <Button
                            color="success"
                            className="w-100"
                            type="submit"
                            disabled={loader && true}
                          >
                            Registrati
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Possiedi già un account?{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {" "}
                      Accedi{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Register;
